import React, { useEffect, useState } from "react";
import "./Stepper.scss";

import Warning from '../../../../assets/images/icons/caution.png';
import Success from '../../../../assets/images/icons/check.png';
import Error from '../../../../assets/images/icons/cancel.png';
import { useAppSelector } from "../../../../features";
import { getMakewithdrawalStatus } from "../../../../store/TransactionSlice";

const Stepper = ({ currentStep = 1 }) => {

  const withdrawalStatus = useAppSelector(getMakewithdrawalStatus);
  const [status, setStatus] = useState<number | typeof NaN>(0)

  const steps = [1, 2, 3, 4];

  const changeNumberToText = (num: Number) => {
    if (num === 1) return 'one';
    if (num === 2) return 'two';
    if (num === 3) return 'three';
    if (num === 4) return 'four';
  }
  
  const changeStatustoImg = (num: Number) => {
    if (num === 201 || num === 200) return Success;
    if (num === 400) return Warning;
    else return Error;
  }

  useEffect(() => {
      setStatus(withdrawalStatus);
  }, [withdrawalStatus]);

  return (
    <div className="stepper-wrapper">

      <div className="stepper-line"></div>
      <div className="stepper-container">
        {steps.map((step, index) => (
          <div key={step} className="step-container">
            {/* Circle */}
            <div className={ `step-circle ${currentStep+1 >= step ? "active-step" : "inactive-step"} ${changeNumberToText(step)} ${step < currentStep+1 ? 'opacity' : ''} `} >
              {step && step < 4 && step}
              {step && step === 4 &&
                <>
                  { status > 0 && 
                    <>
                      <img src={changeStatustoImg(withdrawalStatus)} alt="" />
                    </>
                  }
                  { !status &&
                    <>
                      {step}
                    </>
                  }
                </>
              }
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stepper;